// TokenChecker.js

import axios from 'axios';
const API_URL = process.env.REACT_APP_API_URL;

const validateTokens = async (accessToken, refreshToken) => {
  try {
    const response = await axios.post(`${API_URL}/token/validate/`, {
      access_token: accessToken,
      refresh_token: refreshToken
    },
    {
      headers: {
        "X-CLIENT-API-KEY": process.env.REACT_APP_API_KEY,
      },
    }
  
  );

    if (response.data.valid_access_token && response.data.valid_refresh_token) {
      return true;
    } else {
      // Handle invalid tokens scenario
      return false;
    }
  } catch (error) {
    console.error('Error validating tokens:', error);
    // Handle error scenario
    return false;
  }
};

export default validateTokens;
